(function () {
  let modules = window.__vaahiniDeferredModules;
  if (!Array.isArray(modules) || modules.length === 0) return;

  if ('popover' in HTMLElement.prototype) {
    modules = modules.filter(function (src) {
      return !src.includes('popover-polyfill');
    });
  }

  let loaded = false;

  function loadScript(src) {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = src;
    script.fetchPriority = 'low';
    document.head.appendChild(script);
  }

  function isPriorityModule(src) {
    return (
      src.includes('product-card') ||
      src.includes('product-price')
    );
  }

  function loadAll() {
    if (loaded) return;
    loaded = true;

    const priority = modules.filter(isPriorityModule);
    const deferred = modules.filter(function (src) {
      return !isPriorityModule(src);
    });

    priority.forEach(loadScript);

    deferred.forEach(function (src, index) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(
          function () {
            loadScript(src);
          },
          { timeout: 2500 + index * 400 }
        );
      } else {
        setTimeout(function () {
          loadScript(src);
        }, 150 + index * 200);
      }
    });
  }

  function scheduleIdleLoad() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadAll, { timeout: 5000 });
      return;
    }

    setTimeout(loadAll, 4000);
  }

  const interactionSelector =
    'product-card, .native-cart-add__button, .quick-add__button, .add-to-cart-button, header-component a';

  ['pointerdown', 'keydown', 'touchstart', 'click'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        if (event.target instanceof Element && event.target.closest(interactionSelector)) {
          loadAll();
        }
      },
      { passive: true }
    );
  });

  document.addEventListener(
    'mouseover',
    function (event) {
      if (event.target instanceof Element && event.target.closest('product-card, .native-cart-add, .quick-add')) {
        loadAll();
      }
    },
    { passive: true }
  );

  if (document.readyState === 'complete') {
    scheduleIdleLoad();
  } else {
    window.addEventListener('load', scheduleIdleLoad, { once: true });
  }
})();
